import { CreateElement, FunctionalComponentOptions } from "vue";
import { Resource } from "@megarax/client/src";
import { ListActions } from "@megarax/client/src/list";
import { FullResourceActions } from "@megarax/client/src/actions";
import ItemList from "./ItemList.vue";

export const getItemList = (resource: Resource<ListActions<any>>) =>
  ({
    functional: true,
    render: (h: CreateElement, { listeners, props }) =>
      h(ItemList, { props: { resource, ...props }, on: listeners }),
  } as FunctionalComponentOptions);

export const getDefaultModuleComponents = (
  resource: Resource<FullResourceActions<any, any>>,
) => ({
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: getItemList(resource) as any,
});
